import {Active, Over} from '@dnd-kit/core';

import {isNil} from 'ramda';

import {buildPhotoGuideLayoutContainerId} from './buildPhotoGuideLayoutContainerId';
import {getDndOverContainerId} from './getDndOverContainerId';
import {parsePhotoGuideSlotDndId} from './parsePhotoGuideSlotDndId';
import {parseSortableDndItemId} from './parseSortableDndItemId';

/**
 * An empty slot may only be reordered within its own Guide Layout. Dropped anywhere else (the
 * Backlog, another album) the drop is cancelled, so no album tries to move a photo that is none.
 */
export const isPhotoGuideSlotDropOutsideLayout = (active: Active, over: Over | null) => {
  const activeItem = parseSortableDndItemId(active.id);
  if (isNil(activeItem) || isNil(parsePhotoGuideSlotDndId(activeItem.id)) || isNil(over)) {
    return false;
  }
  return getDndOverContainerId(over) !== buildPhotoGuideLayoutContainerId(activeItem.containerId);
};
